import { Gauge, Crosshair, MessageCircle, Layers, ClipboardCheck } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const POINTS = [
  {
    icon: Gauge,
    title: "تخصص في حساسات ضغط الكفرات",
    desc: "تركيز كامل على أنظمة TPMS: بيع وبرمجة وفحص واستبدال، بدل التشتت بين خدمات عامة.",
  },
  {
    icon: Crosshair,
    title: "مساعدة في تحديد المتوافق",
    desc: "نراجع بيانات سيارتك (الموديل وسنة الصنع ونوع النظام) لتحديد الحساس المناسب قبل الطلب.",
  },
  {
    icon: MessageCircle,
    title: "تواصل سهل عبر واتساب",
    desc: "كل الاستفسارات وطلبات الأسعار عبر واتساب مباشرة — بدون نماذج معقدة أو انتظار.",
  },
  {
    icon: Layers,
    title: "خيارات متعددة حسب المتوفر",
    desc: "حساسات أصلية وبديلة وقابلة للبرمجة حسب التوفر، مع توضيح الفروقات بينها بصراحة.",
  },
  {
    icon: ClipboardCheck,
    title: "توضيح الخدمة قبل الطلب",
    desc: "نشرح لك حالة حساسك وما تحتاجه سيارتك بالضبط قبل أي خطوة، دون التزامات مسبقة.",
  },
];

export const WhyUs = () => (
  <section
    data-testid="why-us-section"
    className="bg-[#08090C] py-20 sm:py-28 relative overflow-hidden"
  >
    <div className="absolute inset-0 tech-grid-bg opacity-40" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="Why Us"
        title="لماذا حساسات كفرات الرياض؟"
        desc="منصة تقنية متخصصة في أنظمة مراقبة ضغط الإطارات — وليست مجرد محل تقليدي."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {POINTS.map((p, i) => {
          const Icon = p.icon;
          return (
            <Reveal key={p.title} delay={i * 0.07}>
              <div className="metal-card rounded-2xl p-6 h-full hover:border-red-500/35 transition-colors">
                <div className="w-11 h-11 rounded-xl bg-red-600/10 border border-red-500/25 flex items-center justify-center mb-4">
                  <Icon size={20} className="text-red-500" />
                </div>
                <h3 className="font-display font-bold text-white text-base mb-2">{p.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
